var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", [[_c("el-form", {
    attrs: {
      inline: true
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "日期"
    }
  }, [[_c("data-options", {
    attrs: {
      clearable: false
    },
    model: {
      value: _vm.formData,
      callback: function callback($$v) {
        _vm.formData = $$v;
      },
      expression: "formData"
    }
  })]], 2), _c("br"), _c("el-form-item", {
    attrs: {
      label: "选择设备："
    }
  }, [_c("el-select", {
    attrs: {
      clearable: "",
      placeholder: "请选择"
    },
    model: {
      value: _vm.searchInfo.device_type,
      callback: function callback($$v) {
        _vm.$set(_vm.searchInfo, "device_type", $$v);
      },
      expression: "searchInfo.device_type"
    }
  }, _vm._l(_vm.deviceOptions, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "选择游戏类型："
    }
  }, [_c("el-select", {
    attrs: {
      clearable: "",
      placeholder: "请选择"
    },
    model: {
      value: _vm.searchInfo.app_name,
      callback: function callback($$v) {
        _vm.$set(_vm.searchInfo, "app_name", $$v);
      },
      expression: "searchInfo.app_name"
    }
  }, _vm._l(_vm.appOptions, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "渠道："
    }
  }, [_c("ChannelOptions", {
    model: {
      value: _vm.searchInfo.channel_id,
      callback: function callback($$v) {
        _vm.$set(_vm.searchInfo, "channel_id", $$v);
      },
      expression: "searchInfo.channel_id"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "选择维度："
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "请选择"
    },
    model: {
      value: _vm.searchInfo.grouping,
      callback: function callback($$v) {
        _vm.$set(_vm.searchInfo, "grouping", $$v);
      },
      expression: "searchInfo.grouping"
    }
  }, _vm._l(_vm.editableTabs, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1)], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.checkPage();
      }
    }
  }, [_vm._v("点击查看")])], 1)], 1)]], 2), _c("div", [_c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      "show-summary": "",
      "summary-method": _vm.getSummaries,
      height: "600",
      border: ""
    }
  }, [_vm.grouping == "date_str" ? _c("el-table-column", {
    attrs: {
      prop: "date_str",
      label: "日期",
      sortable: ""
    }
  }) : _vm._e(), _vm.grouping == "device_type" ? _c("el-table-column", {
    attrs: {
      prop: "device_type",
      label: "设备类型"
    }
  }) : _vm._e(), _vm.grouping == "app_name" ? _c("el-table-column", {
    attrs: {
      prop: "app_name",
      label: "游戏类型"
    }
  }) : _vm._e(), _vm._l(_vm.rangeList, function (v, i) {
    return _c("el-table-column", {
      key: i,
      attrs: {
        prop: v,
        label: v + " %",
        align: "center",
        sortable: ""
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn(scope) {
          return [scope.row.loading_percent[v] !== undefined && scope.row.loading_percent[v].num !== undefined ? _c("span", [_c("div", {
            staticClass: "numClass"
          }, [_vm._v(_vm._s(scope.row.loading_percent[v].num))]), _c("div", {
            staticClass: "propClass"
          }, [_vm._v("( " + _vm._s(scope.row.loading_percent[v].prop) + " % )")])]) : _c("span", [_vm._v(" - ")])];
        }
      }], null, true)
    });
  })], 2)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };